/**
 * Availability flag for the AIS vessel layer (spec 16), same shape as the
 * conditions/base `sources` stores. `GET /api/ais/sources` reports
 * `available: false` when the server has no BarentsWatch credentials
 * configured — the toggle in MapControls is only rendered when this is
 * `true`, fetched once at app start.
 */
import { create } from 'zustand';

interface AisSourcesState {
  available: boolean;
  loaded: boolean;
  load: () => Promise<void>;
}

export const useAisSourcesStore = create<AisSourcesState>((set) => ({
  available: false,
  loaded: false,

  load: async () => {
    try {
      const res = await fetch('/api/ais/sources');
      if (!res.ok) return;
      const data = (await res.json()) as { available: boolean };
      set({ available: data.available, loaded: true });
    } catch {
      /* offline / not configured — stay hidden */
    }
  },
}));
